import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export function Hero() {
  const { t } = useTranslation();

  useEffect(() => {
    if (window.location.hash === '#hero-video') {
      const el = document.getElementById('hero-video');
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 200);
      }
    }
  }, []);
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-50 to-white pt-16 pb-20 lg:pt-24 lg:pb-28">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-teal-200/20 rounded-full blur-3xl mix-blend-multiply animate-blob"></div>
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-200/20 rounded-full blur-3xl mix-blend-multiply animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-1/2 w-72 h-72 bg-pink-200/20 rounded-full blur-3xl mix-blend-multiply animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          <div className="max-w-2xl">
            {/* Title */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.15] mb-6">
              {t('home.title')}
            </h1>
            {/* Subtitle and extra */}
            <p className="text-lg sm:text-xl text-slate-600 mb-8 leading-relaxed">
              {t('home.subtitle')}
              <span className="block mt-2">
                {t('home.extra')}
              </span>
            </p>
            {/* Floating card above video */}
            <div className="flex justify-center mb-6">
              <div className="bg-white p-4 rounded-xl shadow-xl border border-slate-100 animate-float flex items-center gap-3">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-slate-500">{t('home.weekly_sales')}</p>
                  <p className="text-lg font-bold text-slate-900">+24%</p>
                </div>
              </div>
            </div>
          </div>
          {/* Right column left empty for layout symmetry */}
          <div></div>
        </div>
      </div>

      {/* Absolutely positioned full-width video after intro, outside container */}
      <div
        id="hero-video"
        className="mb-10 flex justify-center"
        style={{ width: '100%' }}
      >
        <div style={{ width: '80vw', maxWidth: 1200 }} className="rounded-2xl bg-slate-900/5 p-2 ring-1 ring-inset ring-slate-900/10 lg:rounded-2xl lg:p-4">
          <div className="rounded-xl bg-white shadow-2xl ring-1 ring-slate-900/10 overflow-hidden aspect-video">
            <video
              className="w-full h-full object-cover"
              src="/videos/elora-hero.mp4"
              poster="/images/food.jpg"
              autoPlay
              loop
              muted
              playsInline
            />
            {/* Overlay gradient for better text readability if needed, or just style */}
            <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-xl"></div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}